var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[
            ("" + _vm.classPrefix),
            _vm.type && (_vm.classPrefix + "--type-" + _vm.type),
            _vm.size && (_vm.classPrefix + "--size-" + _vm.size),
            _vm.block && (_vm.classPrefix + "--block"),
            _vm.circle && (_vm.classPrefix + "--circle"),
            _vm.circle && !_vm.onlyIconCircle && (_vm.classPrefix + "--circle-text"),
            {
                'is-disabled': _vm.disabled,
                'is-loading': _vm.loading
            }
        ],attrs:{"disabled":_vm.disabled},on:{"click":_vm.handleClick}},[(_vm.loading)?_c('Icon',{staticClass:"animation-rotate",attrs:{"type":"loading"}}):(_vm.icon)?_c('Icon',{attrs:{"type":_vm.icon}}):_vm._e(),(_vm.$slots.default)?_c('span',[_vm._t("default")],2):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }